export enum M2NodeType {
  Node = "Node",
  Scene = "Scene",
  Sprite = "Sprite",
  Label = "Label",
  TextLine = "TextLine",
  Shape = "Shape",
  Composite = "Composite",
  SoundPlayer = "SoundPlayer",
  SoundRecorder = "SoundRecorder",
}
